import React from 'react';
import { WandSparkles } from 'lucide-react';
import GradientButtonCentered from '@/components/ui/GradientButtonCentered';

interface GenerateButtonProps {
  isReady: boolean;
  isLoading: boolean;
  onGenerate: () => void;
}

const GenerateButton: React.FC<GenerateButtonProps> = React.memo(({
  isReady,
  isLoading,
  onGenerate
}) => {
  return (
    <div className="flex justify-center mt-6">
      <GradientButtonCentered 
        onClick={onGenerate}
        disabled={!isReady} // Now only checks for minimum 1 word, not research type
        variant="purple"
        icon={<WandSparkles className="h-5 w-5" />}
        isLoading={isLoading}
        fullWidth={true}
        testId="generate-research-button"
      >
        {isLoading ? 'Generating Research...' : 'Generate Research'}
      </GradientButtonCentered>
    </div>
  );
});

GenerateButton.displayName = 'GenerateButton';

export default GenerateButton;
